export default {
  'sidebar.title.enterprises': 'Entreprises',
  'sidebar.title.transactions': 'Transactions',
  'sidebar.title.cards': 'Cartes',
  'sidebar.title.offers': 'Offres',
  'sidebar.title.notifications': 'Notifications',

  'sidebar.title.service': 'Service+'
}